// extracted by mini-css-extract-plugin
export var buttons = "_a0-0";
export var buttonsActive = "_a0-h";
export var cancelConfirm = "_a0-1";
export var closeButton = "_a0-2";
export var column = "_a0-3";
export var container = "_a0-4";
export var detailHeader = "_a0-6";
export var detailTitle = "_a0-7";
export var detailsContent = "_a0-5";
export var header = "_a0-8";
export var headerWithClose = "_a0-9";
export var icon = "_a0-a";
export var infoIcon = "_a0-c";
export var informationContainer = "_a0-b";
export var sideDrawer = "_a0-d";
export var sideDrawerOpen = "_a0-e";
export var stickyFooter = "_a0-f";
export var typeOption = "_a0-g";